<template>
  <div class="container-fluid">
    <audit-header :audit="audit"/>

    <div class="row m-t-20" v-if="audit">
      <div class="col-12">
        <div class="card">
          <div class="card-body card-blue">
            <div class="d-flex">
              <div>
                <ul class="nav nav-pills custom-pills" id="pills-tab" role="tablist">
                  <li @click="tab('farm')" class="nav-item p-t-5">
                    <a :class="{'active': activeTab === 'farm'}" aria-selected="true" class="nav-link"
                       data-toggle="pill" href="#af" role="tab">
                      <i class="fas fa-seedling"/> Info
                    </a>
                  </li>
                  <li @click="tab('notes')" class="nav-item p-t-5">
                    <a :class="{'active': activeTab === 'notes'}" aria-selected="true" class="nav-link"
                       data-toggle="pill" href="#af" role="tab">
                      <i class="fas fa-sticky-note"/> Notes
                    </a>
                  </li>
                  <li :key="impactArea.abbreviation" @click="tab(impactArea.abbreviation)"
                      class="nav-item  p-t-5 food_safety" v-for="impactArea in audit.impact_areas">
                    <a :class="{'active': activeTab === impactArea.abbreviation}" :href="'#'+impactArea.abbreviation"
                       aria-selected="true" class="nav-link" data-toggle="pill" role="tab">
                      <i class="fas fa-leaf"/>
                      {{ impactArea.name }}
                    </a>
                  </li>
                  <li @click="tab('custom')" class="nav-item p-t-5">
                    <a :class="{'active': activeTab === 'custom'}" aria-selected="true" class="nav-link"
                       data-toggle="pill" href="#custom" role="tab">
                      <i class="fab fa-whmcs"/> Custom
                    </a>
                  </li>
                  <li @click="tab('attachments')" class="nav-item p-t-5">
                    <a :class="{'active': activeTab === 'attachments'}" aria-selected="false" class="nav-link"
                       data-toggle="pill" href="#attachments" role="tab">
                      <i class="fas fa-paperclip"/> Attachments
                    </a>
                  </li>
                  <li @click="tab('auditlink')" class="nav-item  p-t-5">
                    <a :class="{'active': activeTab === 'auditlink'}" aria-selected="false" class="nav-link"
                       data-toggle="pill" href="#auditlink" role="tab"><i class="fas fa-link"/> Link Audit</a>
                  </li>
                  <!--                                    <li @click="tab('timeline')" class="nav-item p-t-5">-->
                  <!--                                        <a :class="{'active': activeTab === 'timeline'}" aria-selected="false"-->
                  <!--                                           class="nav-link" data-toggle="pill"-->
                  <!--                                           href="#timeline" role="tab"><i-->
                  <!--                                                class="fas fa-clock"></i> Timeline</a>-->
                  <!--                                    </li>-->
                  <li @click="tab('auditorAssignment')"
                      class="nav-item p-t-5"
                      v-if="audit.status !== 'Completed' && audit.auditing_org === activeGroup.anonymous_account">
                    <a :class="{'active': activeTab === 'auditorAssignment'}"
                       aria-selected="false"
                       class="nav-link"
                       data-toggle="pill"
                       href="#attachments"
                       role="tab">
                      <i class="fas fa-user"></i>&nbsp;Auditor Assignment</a>
                  </li>
                </ul>
              </div>
              <div class="ml-auto">
                <div class="btn-group">
                  <button aria-expanded="false" aria-haspopup="true" class="btn btn-primary dropdown-toggle"
                          data-toggle="dropdown" type="button">
                    Action
                  </button>
                  <div class="dropdown-menu">
                    <a @click="print_clicked = true" class="dropdown-item" data-target="#printAuditModal"
                       data-toggle="modal" href="javascript:void(0)">Print</a>
                    <a
                      @click="setStatus('Completed')"
                      class="dropdown-item" data-target="#acceptModal" data-toggle="modal" href="javascript:void(0)"
                      v-if="audit.status==='InProgress' && activeGroup && audit.auditing_org === activeGroup.anonymous_account">Complete</a>
                  </div>
                </div>
              </div>
            </div>

            <div class="tab-content tabcontent-border p-t-40">
              <div :class="{'show': activeTab === 'farm'}" class="tab-pane active" id="farm" role="tabpanel">
                <farm :auditId="auditId" :auditor="audit.auditors" :status="audit.status" v-if="activeTab === 'farm'"/>
              </div>
              <div :class="{'show': activeTab === 'notes'}" class="tab-pane active" id="notes" role="tabpanel">
                <notes :auditId="auditId" :auditType="'RSPO'" :auditor="audit.auditors"
                       :auditorNotes="audit.auditor_notes"
                       :status="audit.status" v-if="activeTab === 'notes'"/>
              </div>
              <div :class="{'show': activeTab === impactArea.abbreviation}" :id="impactArea.abbreviation"
                   :key="impactArea.abbreviation"
                   class="tab-pane active" role="tabpanel" v-for="impactArea in audit.impact_areas">
                <impact-area :auditId="auditId" :auditStatus="audit.status"
                             :auditor="audit.auditors" :certificationId="impactArea.certification"
                             :impactArea="impactArea"
                             v-if="activeTab === impactArea.abbreviation"/>
              </div>
              <!--                            <div :class="{'show': activeTab === 'food_safety'}" class="tab-pane active" id="food_safety"-->
              <!--                                 role="tabpanel">-->
              <!--                                <fs :audit-status="audit.status" :audit-id="auditId" :auditor="audit.auditor"-->
              <!--                                    v-if="activeTab === 'food_safety'"></fs>-->
              <!--                            </div>-->
              <div :class="{'show': activeTab === 'custom'}" class="tab-pane active" id="custom" role="tabpanel">
                <custom-template :auditId="auditId" :auditStatus="audit.status" :auditor="audit.auditors"
                                 v-if="activeTab === 'custom'"/>
              </div>
              <div :class="{'show': activeTab === 'attachments'}" class="tab-pane active" id="attachments"
                   role="tabpanel">
                <attachments :auditId="auditId" :auditor="audit.auditors" :status="audit.status"
                             v-if="activeTab === 'attachments'"/>
              </div>
              <div :class="{'show': activeTab === 'auditlink'}" class="tab-pane active" id="auditlink" role="tabpanel">
                <audit-link :auditId="auditId" :auditType="audit.certification_name"
                            :isAuditingOrg="activeGroup && (audit.auditing_org === activeGroup.anonymous_account)"
                            v-if="activeTab === 'auditlink'"/>
              </div>
              <!--                            <div :class="{'show': activeTab === 'timeline'}" class="tab-pane active" id="timeline"-->
              <!--                                 role="tabpanel">-->
              <!--                                <timeline :audit-id="auditId" :audittype="audit.certification_name"-->
              <!--                                          v-if="activeTab === 'timeline'"></timeline>-->
              <!--                            </div>-->
              <div :class="{'show': activeTab === 'auditorAssignment'}"
                   class="tab-pane active" id="auditors" role="tabpanel">
                <auditor-assignment-tab :auditId="auditId"
                                        v-if="activeTab === 'auditorAssignment'"></auditor-assignment-tab>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div aria-labelledby="proposalModalLabel1" class="modal fade CAB" id="printAuditModal" role="dialog" tabindex="-1">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button @click="printDiv" class="btn btn-primary btn-outline m-l-5 ml-auto" data-dismiss="modal" id="print"
                    type="button">
              <span><i class="fa fa-print"/> Print</span>
            </button>
            <button class="btn btn-secondary btn-outline m-l-5" data-dismiss="modal" id="close" type="button">
              <span><i class="fa fa-ban"/> Close</span>
            </button>
          </div>
          <div class="modal-body">
            <print-audit-template :audit="audit" :audit-id="auditId" :auditor="audit.auditors" v-if="print_clicked"/>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary btn-outline m-l-5 ml-auto" data-dismiss="modal" id="print2" type="button">
              <span><i class="fa fa-print"/> Print</span>
            </button>
            <button class="btn btn-secondary btn-outline m-l-5" data-dismiss="modal" id="close2" type="button">
              <span><i class="fa fa-ban"/> Close</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade" id="acceptModal" role="dialog"
         tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="exampleModalLabel1">Are you sure you want to complete this audit?</h4>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button"><span
              aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="form-group">
                <label class="control-label">Comments:</label>
                <textarea class="form-control" id="message-text1" v-model="comments"></textarea>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button :disabled="completeShow" @click="save"
                    class="btn waves-effect waves-light btn-success"
                    type="button">
              <span v-if="!completeShow">Yes</span>
              <span v-if="completeShow"><i class="fa fa-spinner fa-spin"/> &nbsp;Loading</span>
            </button>
            <button class="btn waves-effect waves-light btn-danger" data-dismiss="modal" type="button">
              No
            </button>
          </div>
        </div>
      </div>
    </div>
    <proposal-stat :proposal="proposal"/>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import EventBus from '@/event-bus';
  // import Timeline from "../Timeline.vue";
  // import MultiSelect from "vue-multiselect";
  import Attachments from '../Attachments.vue';
  import Farm from '../ViewOrEditCluster.vue';
  import Notes from '../Notes.vue';
  // import LandTitle from "../LandTitle.vue";
  // import AttachmentList from "../AttachmentList.vue";
  import AuditLink from '../AuditLink.vue';
  import ImpactArea from './ImpactArea.vue';
  import CustomTemplate from './CustomTemplate.vue';
  import PrintAuditTemplate from '../printTemplate/PrintAuditTemplate.vue';
  import ProposalStat from '@/components/protected/common/ProposalStat.vue';
  import AuditHeader from '../../common/AuditHeader.vue';
  import AuditorAssignmentTab from '@/components/protected/audits/AuditorAssignmentTab';
  import {apiMixin} from '@/utils/api-mixin';

  export default {
    name: 'AuditTemplate',
    mixins: [apiMixin('audit')],
    components: {
      AuditorAssignmentTab,
      ProposalStat,
      PrintAuditTemplate,
      CustomTemplate,
      ImpactArea,
      // Timeline,
      // MultiSelect,
      Attachments,
      Farm,
      Notes,
      // LandTitle,
      // AttachmentList,
      AuditLink,
      AuditHeader
    },
    props: ['auditId', 'auditor'],
    data() {
      return {
        current_user_role: null,
        submitted: false,
        timeline: [],
        currentTimelineIndex: Number,
        indicatorId: null,
        activeTab: 'farm',
        completeShow: false,
        approveShow: true,
        statusTo: null,
        audit: {
          auditors: null
        },
        proposal: null,
        print_clicked: false,
        comments: null
      };
    },
    computed: {
      ...mapGetters(['currentUser', 'activeGroup', 'publicKey'])
    },
    mounted() {
      this.init();
    },
    methods: {
      async init() {
        await this.getAuditById(this.auditId);
      },
      async getAuditById(auditId) {
        try {
          EventBus.$emit('showBlockUI');
          this.audit = (await this.$api.get('/audits/' + auditId)).data;

          EventBus.$emit('auditStatus', this.audit.status);
        } catch (e) {
          console.error(e);
        } finally {
          EventBus.$emit('hideBlockUI');
        }
      },
      setStatus(status) {
        this.statusTo = status;
      },
      tab(tabName) {
        this.activeTab = tabName;
      },
      printDiv() {
        EventBus.$emit('printDiv');
      },
      async save() {
        $('#acceptModal').modal('toggle');
        this.submitted = false;
        this.approveShow = false;
        // eslint-disable-next-line no-unused-vars
        let isProposal = false;
        if (this.activeGroup && this.activeGroup.threshold > 1) {
          isProposal = true;
        }
        await this.callApi('loader', isProposal, 'Audit Completed', async () => {
          await this.$api.patch(`/audits/${this.auditId}/complete`, {
            comments: this.comments
          });
        });
        if (isProposal) {
          this.$router.push({name: 'proposals'});
        }
        await this.getAuditById(this.auditId);
        EventBus.$emit('auditStatus', this.statusTo);
        this.statusTo = null;
      },
      async getProposal(proposal_id) {
        this.proposal = null;
        try {
          const {data} = await this.$api.get(`/groups/proposals/${proposal_id}`);
          const yes_voters = data.votes.ayes.length > 0 ? data.votes.ayes.map(y => y[0]) : [];
          const no_voters = data.votes.nays.length > 0 ? data.votes.nays.map(n => n[0]) : [];
          if (yes_voters.includes(this.publicKey)) {
            data.status = 'Approved';
          } else if (no_voters.includes(this.publicKey)) {
            data.status = 'Rejected';
          } else {
            data.status = 'Pending';
          }
          this.proposal = data;
          this.proposal.voters = yes_voters;
        } catch (e) {
          console.error(e);
        } finally {
          $('#proposalModal').modal('toggle');
        }
      }
    }
  }
</script>

<style scoped>
  .modal-lg {
    max-width: 1800px !important;
  }

  .bws-ico {
    width: 20px;
  }
</style>
